import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MyDetails } from "./MyDetails";
import { MyOrders } from "./MyOrders";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { CgProfile } from "react-icons/cg";
import { IoBagHandleOutline } from "react-icons/io5";
import { IoIosHeartEmpty } from "react-icons/io";
import { BiLogOut } from "react-icons/bi";
import { Mywishlist } from "./MyWishlist";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { borderRadius } from "@mui/system";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 400 },
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 3,
};

export function Profile() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [Content, setContent] = useState(<MyDetails />);
  const navigate = useNavigate();

  function handleMenu(menu) {
    setContent(menu);
  }
  function handleLogout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    navigate("/login");
  }

  
  return (
    <div className="HomeMainContainer container">
      <div className="account-title">MY ACCOUNT</div>
      <Breadcrumb className="custom-breadcrumb">
        <Breadcrumb.Item href="/">HOME</Breadcrumb.Item>
        <Breadcrumb.Item href="/profile">MY ACCOUNT</Breadcrumb.Item>
      </Breadcrumb>
      <div className="profile-subcontainer">
        <div className="profile-list">
          <div onClick={() => handleMenu(<MyDetails />)}>
            <span>
              <CgProfile />
            </span>
            My Details
          </div>
          <div onClick={() => handleMenu(<MyOrders />)}>
            <span>
              <IoBagHandleOutline />
            </span>
            My Orders
          </div>
          <div onClick={() => handleMenu(<Mywishlist />)}>
            <span>
              <IoIosHeartEmpty />
            </span>
            Wishlist
          </div>

          <div>
            <Button
              onClick={handleOpen}
              sx={{ textTransform: "none" }}
              className="btnProfileLogout"
            >
              <span>
                <BiLogOut />
              </span>
              Logout
            </Button>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div className="logout-modalContent">
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div
                      onClick={handleClose}
                      style={{ cursor: "pointer", fontSize: "16px" }}
                    >
                      <IoIosCloseCircleOutline />
                    </div>
                  </div>
                  <div className="logout-modalText">
                    Are you sure you want to log out?
                  </div>
                  <div className="logout-modalDesc">
                    We hope you found everything you were looking for! Log out
                    securely and visit us again soon.
                  </div>
                  <div className="logout-modalBtn">
                    <div onClick={handleClose}>
                      <button className="btnModalCancel" onClose={handleClose}>
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button className="btnModalLogout" onClick={handleLogout}>
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              </Box>
            </Modal>
          </div>
        </div>
        <div className="profile-content">{Content}</div>
      </div>
    </div>
  );
}
